<template>
  <div class="add YTemplate" >
    <div class="YTitle">新增装修巡检</div>
     <div class="main YFrom2">
       <el-form :model="formInline" :rules="rules" ref="rules" :label-width='`${ 160 / 192 }rem`'>
        <el-form-item label="巡检标题 ：" prop="title" >
          <el-input v-model.trim="formInline.title" placeholder="请输入巡检标题"></el-input>
        </el-form-item>
        <el-form-item label="巡检描述 ：" prop="description">
          <el-input type="textarea" :rows="3" v-model.trim="formInline.description" placeholder="请输入巡检描述"></el-input>
        </el-form-item>
        <el-form-item label="图片上传 ：" prop="imgUpload">
          <el-upload
            class="upload-demo"
            :headers='token'
            name='fileName'
            :on-remove="onRemove"
            :on-success='onSuccess'
            :action="imgUrl"
            :data='imgData()'
            :file-list="fileList"
            :before-upload="beforeAvatarUpload"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="商户名称 ：" prop="shopName">
          <el-input v-model.trim="formInline.shopName" @focus="selectIsShow = true"  placeholder="请选择商户名称"></el-input>
        </el-form-item>
       </el-form>
       <div class="btn">
        <el-button type="primary" round @click="save('rules')">新增</el-button>
        <el-button plain round @click="close('rules')">返回</el-button>
      </div>
     </div>
     <transition name="el-fade-in-linear">
       <SelectMerchant v-if="selectIsShow" @close="selectIsShow = false" @select="getSelectVal" />
     </transition>
  </div>
</template>
<script>
import api from '@/shared/api/auth'
import requestApi from '@/shared/api/apps/inspection'
import apiUrl from '@/shared/api/config/api'
import Params from '@/shared/utils/Params'
import SelectMerchant from '../../dailyInspection/components/SelectMerchant'
export default {
  components: {
    SelectMerchant
  },
  data () {
    return {
      selectIsShow: false,
      imgUrl: `${apiUrl.api.protocol}://${apiUrl.api.host}:${apiUrl.api.port === '' ? '' : apiUrl.api.port === '80' ? '' : apiUrl.api.port}`,
      token: { Authorization: sessionStorage.getItem('token') },
      formInline: {
        title: '',
        description: '',
        shopName: ''
      },
      fileList: [],
      imgArrs: [],
      shopNameArr: [],
      rules: {
        title: [
          { required: true, message: '请输入巡检标题', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入巡检描述', trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: '请选择商户名称', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    getSelectVal (e) {
      this.formInline.shopId = e.id
      this.formInline.shopName = e.shopFullName
      this.selectIsShow = false
    },
    save (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addInspection()
        } else {
          return false
        }
      })
    },
    // 新增日常巡检
    addInspection () {
      const fileList = this.imgArrs.map(item => {
        if (item.response) {
          return item.response.backend_org_sys_file_upload_response.url
        }
        return item.url
      }).join(',')
      const params = {
        method: requestApi.addRenovation,
        ...this.formInline,
        image: fileList
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_odc_decorationinspection_add_response.code !== '10000') return
        this.$message.success('新增装修巡检单成功')
        this.$emit('hiddenAdd', true)
      }).catch(e => {})
    },
    onSuccess (res, file, fileList) {
      const result = res.backend_org_sys_file_upload_response
      if (result.code === '10000') {
        this.imgArrs.push({ url: file.response.backend_org_sys_file_upload_response.url, name: file.name })
      }
    },
    onRemove (file, fileList) {
      this.imgArrs = fileList
    },
    // 关闭新增弹框后
    close (formName) {
      this.$refs[formName].resetFields()
      this.$emit('hiddenAdd')
    },
    imgData () {
      return Params({}, api.upload)
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (this.formInline.type === 'picture') {
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 或者 PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!')
        }
        return isJPG && isLt5M
      } else {
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!')
        }
        return isLt5M
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .add
    display flex
    flex-direction column
    .main
      flex auto
  .btn
    text-align center
    margin 60px 0
</style>
